var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loggedIn)?_c('div',{staticClass:"page secondary--text",class:{ 'box box_overflow_page': _vm.isOpenDialog },style:({ top: _vm.topCssProp.valuePx })},[_c('app-bar'),_c('sidebar'),_c('router-view')],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }